// import React,{useState} from 'react';
// import "./metricsCard.css";
// import LinkImg from "../../../assets/images/link_svg.jpg";
// import TransactionPopup from './TransactionPopup';

// function MetricsCard({ metrics }) {
//   const [showPopup, setShowPopup] = useState(false);
//   const calculatePercentage = (value, total) => (total > 0 ? (value / total) * 100 : 0);

//   const togglePopup = () => {
//     setShowPopup(!showPopup);
//   };

//   return (
//     <div className="card shadow-sm agent-improvement-metrics-card-container">
//       <div className="card-body">
//         <div className="mb-3 agent-improvement-metrics-header">
//           <label className="agent-improvement-metrics-label d-block">Severity/ Impact:</label>
//           <span
//   className={`agent-improvement-metrics-badge ${
//     metrics?.severity === 'Low'
//       ? 'agent-improvement-metrics-badge-low'
//       : metrics?.severity === 'Medium'
//       ? 'agent-improvement-metrics-badge-medium'
//       : 'agent-improvement-metrics-badge-high'
//   }`}
// >
//   {metrics?.severity}
// </span>
//         </div>

//         <div className="mb-3">
//           <label className="agent-improvement-metrics-label d-block">No. Of Interactions Affected:</label>
//           <div className="agent-improvement-progress-container">
//             <div className="progress agent-improvement-progress-bar-half agent-improvement-progress-custom">
//               <div 
//                 className="progress-bar agent-improvement-progress-bar-success" 
//                 style={{ width: `${calculatePercentage(metrics?.interactionsAffected, metrics?.totalInteractions)}%` }}
//                 role="progressbar"
//                 aria-valuenow={calculatePercentage(metrics?.interactionsAffected, metrics?.totalInteractions)}
//                 aria-valuemin="0"
//                 aria-valuemax="100"
//               ></div>
//             </div>
//             <small className="agent-improvement-progress-ratio">{metrics?.interactionsAffected}/{metrics?.totalInteractions}</small>
//           </div>
//         </div>

//         <div className="mb-3">
//           <label className="agent-improvement-metrics-label d-block">No. Of Escalations:</label>
//           <div className="agent-improvement-progress-container">
//             <div className="progress agent-improvement-progress-bar-half agent-improvement-progress-custom">
//               <div 
//                 className="progress-bar agent-improvement-progress-bar-success" 
//                 style={{ width: `${calculatePercentage(metrics?.escalations, metrics?.totalEscalations)}%` }}
//                 role="progressbar"
//                 aria-valuenow={calculatePercentage(metrics?.escalations, metrics?.totalEscalations)}
//                 aria-valuemin="0"
//                 aria-valuemax="100"
//               ></div>
//             </div>
//             <small className="agent-improvement-progress-ratio">{metrics?.escalations}/{metrics?.totalEscalations}</small>
//           </div>
//         </div>

//         <div className="mb-3">
//           <label className="agent-improvement-metrics-label d-block">No. Of Interactions Affected In Last 24 Hours:</label>
//           <div className="agent-improvement-progress-container">
//             <div className="progress agent-improvement-progress-custom-2 ">
//               <div 
//                 className="progress-bar agent-improvement-progress-bar-warning" 
//                 style={{ width: `${calculatePercentage(metrics?.interactionsLast24h, metrics?.totalInteractionsLast24h)}%` }}
//                 role="progressbar"
//                 aria-valuenow={calculatePercentage(metrics?.interactionsLast24h, metrics?.totalInteractionsLast24h)}
//                 aria-valuemin="0"
//                 aria-valuemax="100"
//               ></div>
//             </div>
//             <small className="agent-improvement-progress-ratio">{metrics?.interactionsLast24h}/{metrics?.totalInteractionsLast24h}</small>
//           </div>
//         </div>

//         <div className="mb-3">
//           <div className="agent-improvement-progress-container">
//             <label className="agent-improvement-metrics-label d-block">Date Of First Identification:</label>
//             <p className="mb-0 agent-improvement-metrics-identification-date">{metrics?.identificationDate}</p>
//           </div>
//         </div>

//         <div className="text-end agent-improvement-metrics-details-link">
//           <button className="btn btn-link text-decoration-none text-primary" onClick={togglePopup}>
//             <span><img src={LinkImg} alt="link icon" /></span> Transaction Level Details
//           </button>
//         </div>
//       </div>
//       <TransactionPopup isVisible={showPopup} onClose={togglePopup} />
//     </div>
//   );
// }

// export default MetricsCard;


// import React, { useState, useEffect, useMemo, useRef } from "react";
// import "./metricsCard.css";
// import transactionVector from "../../../assets/images/transactionVector.png";
// import TransactionPopup from "./TransactionPopup";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchTransactionDetailsInit,
//   setTransactionTable,
// } from "../../../redux/slices/agentHomeSlice";
// import { set } from "date-fns";
// import {
//   setCurrentPage,
//   setPageSize,
//   setSearchFields,
//   setSortFields,
// } from "../../../redux/slices/operationHomeSlice";

// function MetricsCard({ metrics, dataAccessor, currentPage, recommendationCardTitle  }) {
//   const dispatch = useDispatch();
//   const [showPopup, setShowPopup] = useState(false);

//   const pageSize = 5;

//   const previousAgentRecommendation = useRef(null);

//   const AgentRecommendation = useMemo(
//     () => (metrics?.callIds ? metrics?.callIds.split(",") : []),
//     [metrics]
//   );
//   console.log("Received recommendationCardTitle:", recommendationCardTitle);  // Debugging log
//   useEffect(() => {
//     dispatch(setSearchFields(null));
//     dispatch(setPageSize(5));
//     dispatch(setCurrentPage(1));
//   }, [showPopup, dispatch]);
//   useEffect(() => {
//     console.log(metrics, AgentRecommendation);
//     if (
//       !AgentRecommendation ||
//       AgentRecommendation.length === 0 ||
//       previousAgentRecommendation.current === AgentRecommendation
//     ) {
//       console.log("Skipping API call: AgentRecommendation is not ready");
//       return;
//     }
//     previousAgentRecommendation.current = AgentRecommendation;
//     const payload = {
//       CallIds: AgentRecommendation,
//       limit: pageSize,
//       page: Number(currentPage),
//       sortBy: "",
//       sortOrder: "",
//       searchColumn: "",
//       search: "",
//     };

//     dispatch(fetchTransactionDetailsInit(payload));
//   }, [AgentRecommendation, pageSize, currentPage, dispatch]);

//   const calculatePercentage = (value, total) =>
//     total > 0 ? (value / total) * 100 : 0;

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const options = { year: "numeric", month: "long", day: "numeric" };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   const togglePopup = () => {
//     setShowPopup(!showPopup);
//   };
//   //

//   return (
//     <div className="card shadow-sm agent-improvement-metrics-card-container">
//       <div className="card-body">
//         <div className="subcontainer-Title">Interaction & Impact Overview</div>
//         <div className="subContainer">
//           <div className="mb-3">
//             <div className="agent-improvement-progress-container-date">
//               <label className="agent-improvement-metrics-date d-block">
//                 Date Of First Identification:
//               </label>
//               <p className="mb-0 agent-improvement-metrics-identification-date">
//                 {formatDate(metrics?.CreatedOn)}
//               </p>
//             </div>
//           </div>
//           <div className="interaction-container mb-3">
//             <label className="agent-improvement-metrics-label d-block">
//               No. Of Interactions <span className="affected">Affected </span>
//             </label>
//             <div className="agent-improvement-progress-container">
//               <div className="progress agent-improvement-progress-bar-half agent-improvement-progress-custom">
//                 <div
//                   className="progress-bar agent-improvement-progress-bar-warning"
//                   style={{
//                     width: `${calculatePercentage(
//                       metrics?.NoOfInteractionsaffected,
//                       metrics?.totalCalls
//                     )}%`,
//                   }}
//                   role="progressbar"
//                   aria-valuenow={calculatePercentage(
//                     metrics?.NoOfInteractionsaffected,
//                     metrics?.totalCalls
//                   )}
//                   aria-valuemin="0"
//                   aria-valuemax="100"
//                 ></div>
//               </div>
//               <span className="agent-improvement-progress-ratio">
//                 {metrics?.NoOfInteractionsaffected}/{metrics?.totalCalls}
//               </span>
//             </div>
//           </div>

//           <div className="interaction-container mb-3">
//             <label className="agent-improvement-metrics-label d-block">
//               No. Of Escalations
//             </label>
//             <div className="agent-improvement-progress-container">
//               <div className="progress agent-improvement-progress-bar-half agent-improvement-progress-custom">
//                 <div
//                   className="progress-bar agent-improvement-progress-bar-success"
//                   style={{
//                     width: `${calculatePercentage(
//                       metrics?.NoOfEscalations,
//                       metrics?.totalCalls
//                     )}%`,
//                   }}
//                   role="progressbar"
//                   aria-valuenow={calculatePercentage(
//                     metrics?.NoOfEscalations,
//                     metrics?.totalCalls
//                   )}
//                   aria-valuemin="0"
//                   aria-valuemax="100"
//                 ></div>
//               </div>
//               <small className="agent-improvement-progress-ratio">
//                 {metrics?.NoOfEscalations}/{metrics?.totalCalls}
//               </small>
//             </div>
//           </div>

//           <div className="interaction-container mb-3">
//             <label className="agent-improvement-metrics-label d-block">
//               No. Of Interactions Affected In Last 24 Hours
//             </label>
//             <div className="agent-improvement-progress-container">
//               <div className="progress agent-improvement-progress-custom-2 ">
//                 <div
//                   className="progress-bar agent-improvement-progress-bar-warning"
//                   style={{
//                     width: `${calculatePercentage(
//                       metrics?.NoOfInteractionsAffectedIn24Hours,
//                       metrics?.totalCalls
//                     )}%`,
//                   }}
//                   role="progressbar"
//                   aria-valuenow={calculatePercentage(
//                     metrics?.NoOfInteractionsAffectedIn24Hours,
//                     metrics?.totalCalls
//                   )}
//                   aria-valuemin="0"
//                   aria-valuemax="100"
//                 ></div>
//               </div>
//               <small className="agent-improvement-progress-ratio">
//                 {metrics?.NoOfInteractionsAffectedIn24Hours}/
//                 {metrics?.totalCalls}
//               </small>
//             </div>
//           </div>
//         </div>

//         <div
//           className="text-end agent-improvement-metrics-details-link"
//           style={{ position: "relative", top: "-10px", left: "46%" }}
//         >
//           <button
//             className="btn btn-link text-decoration-none"
//             style={{ color: "#FFFFFF", gap: "7px" }}
//             onClick={togglePopup}
//           >
//             <span>
//               <img src={transactionVector} alt="link icon" />
//             </span>{" "}
//             Transaction Level Details
//           </button>
//         </div>
//       </div>
//       <TransactionPopup isVisible={showPopup} onClose={togglePopup} recommendationCardTitle={recommendationCardTitle}/>
//     </div>
//   );
// }

// export default MetricsCard;

import React, { useState, useEffect, useMemo, useRef } from "react";
import "./metricsCard.css";
import transactionVector from "../../../assets/images/transactionVector.png";
import TransactionPopup from "./TransactionPopup";
import { useDispatch, useSelector } from "react-redux";
import { fetchTransactionDetailsInit } from "../../../redux/slices/agentHomeSlice";
import Spinner from "../../../common/components/Spinner/Spinner";
import {
  setCurrentPage,
  setPageSize,
  setSearchFields,
} from "../../../redux/slices/operationHomeSlice";
import UIConfig from "../../../common/constants/UIConfig";

function MetricsCard({
  metrics,
  dataAccessor,
  currentPage,
  recommendationCardTitle,
}) {
  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  const loading = useSelector((state) => state.agentHome.loading);
  const pageSize = 5;
  const previousAgentRecommendation = useRef(null);

  const AgentRecommendation = useMemo(
    () => (metrics?.callIdsAffected ? metrics?.callIdsAffected.split(",") : []),
    [metrics],
  );
  useEffect(() => {
    dispatch(setSearchFields(null));
    // dispatch(setPageSize(5));
    // dispatch(setCurrentPage(1));
  }, [showPopup, dispatch]);

  useEffect(() => {
    if (
      !AgentRecommendation ||
      AgentRecommendation.length === 0 ||
      previousAgentRecommendation.current === AgentRecommendation
    ) {
      return;
    }

    previousAgentRecommendation.current = AgentRecommendation;
    const payload = {
      CallIds: AgentRecommendation,
      limit: pageSize,
      page: Number(currentPage),
      sortBy: "",
      sortOrder: "",
      searchColumn: "",
      search: "",
    };

    dispatch(fetchTransactionDetailsInit(payload));
  }, [AgentRecommendation, pageSize, currentPage, dispatch]);

  const calculatePercentage = (value, total) =>
    total > 0 ? (value / total) * 100 : 0;

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: UIConfig.branding.timeZone || "America/New_York",
    };
    return date.toLocaleDateString("en-US", options);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const isLoading = !metrics;

  return (
    <>
      {isLoading && <Spinner loading={true} />}
    <div className="card shadow-sm agent-improvement-metrics-card-container">
      <div className="card-body">
        <div className="subcontainer-Title">Interaction & Impact Overview</div>
        <div className="subContainer">
          <div className="mb-3">
            <div className="agent-improvement-progress-container-date">
              <label className="agent-improvement-metrics-date d-block">
                Date Of First Identification:
              </label>
              <p className="mb-0 agent-improvement-metrics-identification-date">
                {formatDate(metrics?.CreatedOn)}
              </p>
            </div>
          </div>

          {/* Interactions Affected */}
          <div className="interaction-container mb-3">
            <label className="agent-improvement-metrics-label d-block">
              No. Of Interactions <span className="affected">Affected</span>
            </label>
            <div className="agent-improvement-progress-wrapper">
              <div
                className="agent-improvement-progress-bar warning"
                style={{
                  width: `${calculatePercentage(
                    metrics?.NoOfInteractionsaffected || 0,
                    metrics?.totalCalls || 0
                  )}%`,
                }}
              />
            </div>
            <span className="agent-improvement-progress-ratio">
              {metrics?.NoOfInteractionsaffected}/{metrics?.totalCalls}
            </span>
          </div>

          {/* Escalations */}
          <div className="interaction-container mb-3">
            <label className="agent-improvement-metrics-label d-block">
              No. Of Escalations
            </label>
            <div className="agent-improvement-progress-wrapper">
              <div
                className="agent-improvement-progress-bar success"
                style={{
                  width: `${calculatePercentage(
                    metrics?.NoOfEscalations || 0,
                    metrics?.totalCalls || 0
                  )}%`,
                }}
              />
            </div>
            <span className="agent-improvement-progress-ratio">
              {metrics?.NoOfEscalations}/{metrics?.totalCalls}
            </span>
          </div>

          {/* Interactions Affected in 24 Hours */}
          <div className="interaction-container mb-3">
            <label className="agent-improvement-metrics-label d-block">
              No. Of Interactions Affected In Last 24 Hours
            </label>
            <div className="agent-improvement-progress-wrapper">
              <div
                className="agent-improvement-progress-bar warning"
                style={{
                  width: `${calculatePercentage(
                    metrics?.NoOfInteractionsAffectedIn24Hours || 0,
                    metrics?.totalCalls || 0
                  )}%`,
                }}
              />
            </div>
            <span className="agent-improvement-progress-ratio">
              {metrics?.NoOfInteractionsAffectedIn24Hours}/{metrics?.totalCalls}
            </span>
          </div>
        </div>

        {/* <div className="text-end agent-improvement-metrics-details-link">
          <button
            className="btn btn-link text-decoration-none"
            onClick={togglePopup}
          >
            <img src={transactionVector} alt="link icon" />
            Transaction Level Details
          </button>
        </div> */}
        <div
          className="text-end agent-improvement-metrics-details-link"
          style={{ position: "relative", top: "-10px", left: "46%" }}
        >
          <button
            className="btn btn-link text-decoration-none"
            style={{ color: "#FFFFFF", gap: "7px" }}
            onClick={togglePopup}
          >
            <span>
              <img src={transactionVector} alt="link icon" />
            </span>{" "}
            Transaction Level Details
          </button>
        </div>
      </div>

      <TransactionPopup
        isVisible={showPopup}
        onClose={togglePopup}
        recommendationCardTitle={recommendationCardTitle}
      />
    </div>
    </>
  );
}

export default MetricsCard;


